import { updateSignUpState } from "../../../store/auth.tsx";
import { appendCustomTextResponse } from "../../../store/conversation.tsx";
import { i18n } from "@lingui/core";
import { msg } from "@lingui/core/macro";

const handleInitiateSignUp = (enteredText: string, dispatch: any) => {
  if (
    enteredText.toLowerCase() ===
    i18n
      ._(
        msg({
          message: "create an account",
          context: "Message initiating the signup flow",
        }),
      )
      .toLowerCase()
  ) {
    dispatch(
      updateSignUpState({
        signUpToken: null,
        termsAndConditionsHash: null,
        dataProtectionPolicyHash: null,
        isComplete: false,
      }),
    );
    // This should redirect to google SSO. Later it should ask what platform.
    dispatch(
      appendCustomTextResponse(
        i18n._(
          msg({
            message: `Let me help you create an account! 🚀😊 
         First, choose your preferred single sign on platform. Here are the current options:

         - Google
         - Visma Connect`,
            context:
              "Message informing the user on which providers are available for registration with the application.",
          }),
        ),
      ),
    );
  }
};

export default handleInitiateSignUp;
